import { IAppState } from '../../redux';

export function selectNextBets(state: IAppState): number[] {
  return state.auction.nextBets;
}
